import React from "react";
import CardSlider from "./CardSlider";

const EventSlider = ({ backgroundColor, bannerList }) => {
  return <CardSlider cardData={bannerList} backgroundColor={backgroundColor} />;
};

export default EventSlider;
